// Copyright (c) 2016 Deere & Company

import './labor-additive-summary-modal.scss';
import React, {PropTypes} from 'react';
import DealerPercentageList from './dealer-percentage-list';
import {FormattedMessage} from 'react-intl';
import LaborAdditiveSummary from '@deere/cps-it.warranty-model-factory/lib/labor-additive-summary';
import LaborAdditiveSummaryItemForModal from './labor-additive-summary-item-for-modal';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

function handleModalClose() {

    this.onModalClose();

}

const LaborAdditiveSummaryModal = props =>
    <section className='labor-additive-summary-detail-modal'>
        <WarrantyMediumModal isOpen={props.isVisible}>
            <header>
                <FormattedMessage id='LABOR_ADDITIVE_COMPLETION_DETAIL'/>
                <span
                    className='close-modal-icon'
                    onClick={props::handleModalClose}
                />
            </header>
            <div className='modal-body'>
                <LaborAdditiveSummaryItemForModal laborAdditiveSummary={props.laborAdditiveSummary}/>
                <div className='column-titles'>
                    <span className='dealership'>
                        <FormattedMessage id='DEALERSHIP'/>
                    </span>
                    <span className='percentage'>
                        <FormattedMessage id='PERCENTAGE'/>
                    </span>
                </div>
                <DealerPercentageList
                    dealerPercentages={props.laborAdditiveSummary.dealerPercentages}
                    targetCompletion={props.laborAdditiveSummary.targetCompletion}
                />
            </div>
        </WarrantyMediumModal>
    </section>;

LaborAdditiveSummaryModal.displayName = 'LaborAdditiveSummaryModal';
LaborAdditiveSummaryModal.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    laborAdditiveSummary: PropTypes.instanceOf(LaborAdditiveSummary).isRequired,
    onModalClose: PropTypes.func.isRequired
};

export default LaborAdditiveSummaryModal;



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-summary/labor-additive-summary-modal.js